import emailjs from '@emailjs/browser';

export function sendWelcomeEmail({ id, language, author: { name, email }, message, iteration }) {
	emailjs.send('service_cid04w8', 'template_a9pbtdq', { id, language, name, email, message, iteration }, "user_pGP6EiJ7A3Oef57GSmbZ3").then((response) => {
		console.log('SUCCESS!', response.status, response.text);
	}, (error) => {
		console.log('FAILED...', error);
	});
};

// export const sendCancelationEmail = ({ email, name } = {}) => {
// 	sgMail.send({
// 		to: email,
// 		from: 'coding.trarbach@gmail.com',
// 		subject: 'Sorry to see you go!',
// 		text: `Goodbye ${name}, I hope to see you back sometime soon.`
// 	}).then(() => {
// 		('Cencelation mail sent.')
// 	}).catch((error) => {
// 		console.error(error)
// 	});
// };